export const RADIO_INPUT_SELECTOR = 'data-gourmet-radio-input-input' as const
